/**
 * @generated SignedSource<<bec6fe653ff7b9e78f4f1c1ecb053374>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ticketPreferences_viewer$data = {
  readonly id: string;
  readonly ticketingEmailSignature: string | null;
  readonly ticketingReplyToEmail: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"SettingsProfileSubNav_viewer">;
  readonly " $fragmentType": "ticketPreferences_viewer";
};
export type ticketPreferences_viewer$key = {
  readonly " $data"?: ticketPreferences_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ticketPreferences_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ticketPreferences_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ticketingEmailSignature",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ticketingReplyToEmail",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SettingsProfileSubNav_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "35e6ff6e85655047f113c3bd27314861";

export default node;
